import React, { useEffect } from "react"
import TawkMessengerReact from "@tawk.to/tawk-messenger-react"
import { ChatBot } from "@components"
const Layout = ({ children }: any) => {
  useEffect(() => {
    // Initialize Tawk API object
    ;(window as any).Tawk_API = (window as any).Tawk_API || {}

    // Function to hide the widget
    const hideTawkWidget = () => {
      try {
        const tawkAPI = (window as any).Tawk_API
        if (tawkAPI && typeof tawkAPI.hideWidget === "function") {
          tawkAPI.hideWidget()
          return true // Success
        }
      } catch (error) {
        console.log("Tawk API error:", error)
      }
      return false // Failed
    }

    // Set up onLoad callback
    ;(window as any).Tawk_API.onLoad = function () {
      hideTawkWidget()
    }

    // Polling mechanism to check for API availability
    let attempts = 0
    const maxAttempts = 20 // Try for 10 seconds (20 * 500ms)

    const pollForAPI = () => {
      if (attempts >= maxAttempts) {
        console.log("Tawk API not available after maximum attempts")
        return
      }

      attempts++
      if (hideTawkWidget()) {
        console.log("Tawk widget hidden successfully")
        return
      }

      // Try again in 500ms
      setTimeout(pollForAPI, 500)
    }

    // Start polling after a short delay
    const initialTimer = setTimeout(pollForAPI, 1000)

    return () => {
      clearTimeout(initialTimer)
    }
  }, [])

  return (
    <div>
      {children}
      <TawkMessengerReact
        propertyId="67bf10f4e366d1190c78a606"
        widgetId="1il15kf4d"
      />
      <ChatBot />
    </div>
  )
}

export default Layout
